import { Component, OnInit, input, output, inject } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormBase } from "@app/shared/models/form-base.model";
import { TranslateService } from "@ngx-translate/core";
import _ from "lodash";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

import { FormInputComponent } from "@app/shared/components/form-input/form-input.component";
import { FormSchemaEditorComponent } from "@app/shared/components/form-schema-editor/form-schema-editor.component";
import { FormTextAreaComponent } from "@app/shared/components/form-text-area/form-text-area.component";
import { FormCheckBoxComponent } from "@app/shared/components/form-check-box/form-check-box.component";

@Component({
    selector: "inspekt-dynamic-form-control",
    templateUrl: "./dynamic-form-control.component.html",
    styles: [":host { display: block; width: 100%; }"],
    imports: [
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        FormInputComponent,
        FormSchemaEditorComponent,
        FormTextAreaComponent,
        FormCheckBoxComponent,
    ],
})
export class DynamicFormFieldComponent implements OnInit {
    private translateService = inject(TranslateService);

    readonly index = input<number>(undefined);
    readonly control = input<FormControl>(undefined);
    readonly field = input<FormBase<any>>(undefined);
    public originalField: FormBase<any>;
    public description = "";
    public enum = "";
    readonly notifyParent = output<any>();
    public isDeleted = false;

    ngOnInit() {
        this.originalField = _.cloneDeep(this.field());
        this.getTranslation();
        console.log('DynamicFormFieldComponent')
        console.log(this)
    }

    emitValue() {
        const field = this.field();
        this.notifyParent.emit({
            newField: field,
            oldField: this.originalField,
            index: this.index(),
        });
        this.originalField = _.cloneDeep(field);
    }

    deletePickListOptions(enumValueToDelete) {
        this.isDeleted = true;
        this.notifyParent.emit({ deleteField: enumValueToDelete });
    }

    private getTranslation() {
        this.translateService
            .get("PICK_LIST_EDITOR.PICK_LIST_ITEM_DESC")
            .subscribe((text) => (this.description = text));
        this.translateService
            .get("PICK_LIST_EDITOR.PICK_LIST_ITEM_VALUE")
            .subscribe((text) => (this.enum = text));
    }
}
